import { selectDoc, selectAll, event, addClass, removeClass } from "../utils/utils";
import $ from "jquery";

export class Product {
  constructor(el) {
    if (el) {
      this.init(el);
    }
  }

  init(el) {
    this.el = el;
    this.props();
    this.render();
    this.eventListeners();
    this.eventListenersOnLoad();
  }
  
  props() {
    this.isProductBundle = selectDoc('.product-bundle-product')
    this.productForm = selectDoc("[data-product-form]");
    this.dataQty = selectAll("[data-btnqty]");
    this.inputQty = selectDoc("[data-quantity]");
    this.addToBag = selectAll("[data-btn-add-to-bag]");
    this.cartQtyContainer = selectDoc("[data-cart-qty]");
    this.cartModalClose = selectDoc("[data-cart-modal-close]");
    this.stickyCartContainer = selectDoc("[data-sticky-cart]");
  }

  render() {
    this.cartQty();
    this.cartItems();
    this.stickyCart();
  }

  eventListeners() {
    $("body").on('click', this.closeRcPopup);
    $("body").on('click mouseover', '.rc_popup__label', this.showRcPopup);
  }
  
  eventListenersOnLoad() {
    window.addEventListener("load", function(e) {
      const bundleAddToBag = selectAll('.product__add-to-cart__bundle')
      const stickyBundleAddToBag = selectDoc('.product__add-to-cart__bundle__sticky')
      
      bundleAddToBag.forEach(el => {
        event(el, "click", updateCart) 
      })

      event(stickyBundleAddToBag, "click", () => {
        bundleAddToBag[1].click();
      })

      function updateCart() {
        $.ajax({
          type: 'GET',
          dataType: 'json',
          url: '/cart.json',
          success: function (cart) {
            const elCartModalContainer = document.querySelector("[data-cart-modal]");
            const elQtyModalContainer = document.querySelector("[cart-modal-qty]");
            const elQtyContainer = document.querySelectorAll("[data-cart-qty]");
            const bundleProductsCount = document.querySelectorAll(".mw-gp__table tbody tr").length;

            elCartModalContainer.classList.add("is-active");
            elQtyContainer.forEach(el => {
              el.innerHTML = cart.item_count === "0" ? bundleProductsCount : cart.item_count + bundleProductsCount;
            })
            elQtyModalContainer.innerHTML = bundleProductsCount;
          }
        });
      }
    })
  }

  closeRcPopup(e) {
    $('.rc_popup__block').css('display', 'none');
  }

  showRcPopup() {
    $('.rc_popup__block').css('display', 'block');
  }

  cartQty = () => {
    for (var i = 0; i < this.dataQty.length; i++) {
      this.dataQty[i].addEventListener("click", (e) =>
        updateQty(e)
      );
    };

    let qty = 0;
    
    this.inputQty.addEventListener("change", (e) => 
      updatePrice()
    );

    function updateQty(e) {
      const $btn = $(e.currentTarget);
      const $parent = $(e.currentTarget).parent();
      const $input = $parent.find("[data-quantity]");
      let value = Number($input.val());
      const func = $btn.data("func");
      if (func === "plus") {
        value = value + 1;
        $input.val(value);
      } else if (func === "minus" && value > 1) {
        value = value - 1;
        $input.val(value);
      }
      updatePrice()
    };
    
    function updatePrice() {
      const elPrice = selectDoc("[data-price]");
      const price = elPrice.dataset.price / 100;
      qty = selectDoc("[data-quantity]").value;
      const finalPrice = price * qty
      const isFloat = finalPrice % 1 !== 0
      elPrice.innerHTML = '$' + (isFloat ? finalPrice.toFixed(2) : finalPrice);
    };
  }
  

  cartItems = () => {
    const $elQtyContainer = $("[data-cart-qty]");
    const $elQtyModalContainer = $("[cart-modal-qty]");
    const $elCartModalContainer = $("[data-cart-modal]");

    event(this.cartModalClose, "click", function () {
      $elCartModalContainer.removeClass("is-active");
    });

    for (var i = 0; i < this.addToBag.length; i++) {
      event(this.addToBag[i], "click", function (e) {
        e.preventDefault();
        const quantity = e.currentTarget.classList.contains('sticky') ? 1 : parseInt(selectDoc("[data-quantity]").value);
        const id = window.thisProduct.variants[0].id;
        addItemToCart(id, quantity);

        function addItemToCart(id, quantity) {
          const data = {
            "id": id,
            "quantity": quantity
          }
          const selling_plan = selectDoc("[name='selling_plan']", e.currentTarget.form);
          if (selling_plan && parseInt(selling_plan.value)) {
            data.selling_plan = parseInt(selling_plan.value);
          }
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: function () {
              $.ajax({
                type: 'GET',
                dataType: 'json',
                url: '/cart.json',
                success: function (cart) {
                  $elCartModalContainer.addClass("is-active");
                  $elQtyModalContainer.html(quantity);
                  $elQtyContainer.html(cart.item_count);
                }
              });
            }
          });
        }
      });
    }


  }

  stickyCart = () => {
    const isDesktop = window.innerWidth > 768;
    const stickyCartContainer = this.stickyCartContainer;

    if (!this.isProductBundle) {
      this.createRechargeForm();
    }

    window.addEventListener("scroll", () => {
      const top = window.pageYOffset || document.documentElement.scrollTop;
      if (isDesktop) {
        if (top > 100) {
          addClass(stickyCartContainer, "active");
        } else {
          removeClass(stickyCartContainer, "active");

        }
      } else {
        if (top > 400) {
          addClass(stickyCartContainer, "active");
        } else {
          removeClass(stickyCartContainer, "active");

        }
      }

    });
  }

  formatPrice = () => {
    const isFloat = finalPrice % 1 !== 0
    return '$' + isFloat ? finalPrice.toFixed(2) : finalPrice
  }

  createRechargeForm = () => {
    if (window.ReChargeWidget) {
      const id = window.thisProduct.id;
      window.ReChargeWidget.createWidget({ productId: id, injectionParent: '.rc-custom-injection-point', selectors: { price: ['.product__price'] } });
      window.ReChargeWidget.getWidgets();

      setTimeout(() => {
        this.initRecharge();
      }, 2000);
    } else {
      setTimeout(() => {
        this.createRechargeForm();
      }, 1000);
    }
  }

  initRecharge = () => {
    const isRecharge = selectDoc(".rc-widget-injection-parent")
    const stickyRecharge = selectDoc(".rc-custom-injection-point")
    if (isRecharge.childNodes.length === 0) {
      addClass(this.stickyCartContainer, "no-recharge")
    } else {
      // When there is a recharge widget, give the secondary recharge widget unique handlers
      const els = selectAll('.rc_widget__option__selector > *', stickyRecharge)
      const sel = '_sticky'
      els.forEach(el => {
        if (el.type == 'radio') {
          el.id = el.id + sel
        } else {
          el.htmlFor = el.htmlFor + sel
        }
      });

      // When there is a recharge widget, set plan prices to add to bag buttons
      const priceIndicators = selectAll('[data-price]')
      const rcInit = selectDoc('.rc-radio__input:checked')

      priceIndicators.forEach(indicator => {
        const newPrice = rcInit.nextSibling.querySelector('.rc-option__price').innerHTML.replace(/\$/g,'')
        indicator.dataset.price = newPrice * 100
        const isFloat = newPrice % 1 !== 0
        indicator.innerHTML = '$' + (isFloat ? newPrice.toFixed(2) : newPrice.toString().replace(/\.00$/,''))
        console.log('updating price: ', indicator.innerHTML)
      })

      // On recharge input change, update price in add to bag buttons
      const rcInputs = selectAll('.rc-radio__input')
      rcInputs.forEach(rcOption => {
        event(rcOption, "click", function (e) {
          const isSticky = e.currentTarget.id.indexOf(sel) === -1
          const priceIndicator = isSticky ? priceIndicators[0] : priceIndicators[1];
          const newPrice = rcOption.nextSibling.querySelector('.rc-option__price').innerHTML.replace(/\$/g,'')
          const qty = isSticky ? selectDoc("[data-quantity]").value : 1

          priceIndicator.dataset.price = newPrice * 100
          const finalPrice = newPrice * qty
          const isFloat = finalPrice % 1 !== 0
          priceIndicator.innerHTML = '$' + (isFloat ? finalPrice.toFixed(2) : finalPrice.toString().replace(/\.00$/,''))
        })
      })
    }
  }

}
